module.exports = __webpack_public_path__ + "img/delete-success.cc4a49b8.svg";